import React from 'react';
import '../style/Teaching.scss';
// react bootstrap
import { Container } from 'react-bootstrap';
import Header from '../components/public/Header';

function DreamYoga() {
  return (
    <>
      <Header />
      <Container>
        <div className='content'>
          <h3 className='text-left text-secondary'>夢瑜伽</h3>
          <p className='chineseParagraph'>
            根據統計在人的一生中，花費了大約240,000小時的睡眠時間,可以說人生有27年都在睡覺,真是好浪費啊！正如佛陀所說,如此寶貴的時間,我們可以用來發展更高層次的修行。
            當我們醒著時，我們知道夢是不真實的。但是,不論是醒著或睡著,當我們處於幻覺中時,我們並不知道這是幻覺。我們的意識是如此粗糙混亂及多變
            !
            通過夢想瑜伽的實修,我們可以學習認識這種幻覺。這有助於我們更進一步了解,即使我們清醒的現實生活也是種幻覺。
            結合了種子字和觀想,夢中禪修使我們能夠在夢境中保持意識,以便將夢境用於我們的修持。例如,我們可以觀想一個我分成無量無邊的我,或控制自己的體積變大或變小。我們可以看到本尊，並使它們再次消失。
            儘管在夢中看到的不是真實的,但我們自身的感覺卻是真實的,如恐懼，喜悅等感受在夢中是如此真實。無法將這些體驗視為幻覺,我們會帶來痛苦，如同地獄的定義亦是幻想。
            法尊 索南桑波 云:
            睡夢中陰諸幻象，幻象乃業所習成，騎乘愚痴之馬駒，寬坦悠遊光明原，欸瑪豈非甚妙耶？
            惹瓊巴大師云:精勤者修臍火，懈怠者修夢境。
            瑪爾巴大師云:本來諸法乃如幻，尤以夢幻最殊勝。又說:睡眠之時觀光明，邊集意念邊入禪；縱入愚癡也未懼，因解雙運信念滿；夢境之時觀佛身，邊開境界邊觀修，雖入妄念不恐懼，因懂幻化有信念。
            眾生於有限之身壽當中,如能善加運用睡夢中陰,則不但可幫助行者直指自心本性,更可經由轉化睡夢中陰之情境,進而連結甚至改變生處中陰,行持並利益有情眾生事業。
            自古以來藏區閉關瑜伽行者更將夢瑜珈視為取成就的重要徵兆。
          </p>
        </div>
      </Container>
    </>
  );
}

export default DreamYoga;
